module.exports = __webpack_public_path__ + "media/svg/ee-2d3199d2.svg";